module.exports = __webpack_public_path__ + "img/comment-xmark.280d5ead.svg";